import React from 'react'
import Link from './link'
import Icon from './icon'

type BreadCrumbProps = {
  level: Level | null
  isCurrentPage?: boolean
}

export type Level = {
  levelNumber: number | null
  label: string | null
  slug: string | null
}

export const BreadCrumbCompenent: React.FC<BreadCrumbProps> = ({ level, isCurrentPage = false }) => {
  if (!level) return null

  return (
    <nav aria-label="Fil d'Ariane">
      <ol className="flex items-center space-x-2">
        <li
          className="flex items-center font-medium hover:text-primary"
          key={level.slug}
        >
          {level?.levelNumber === 1 && (
            <Icon
              icon="home"
              className="w-5 h-5 mr-2 place-self-start"
              aria-hidden="true"
            />
          )}
          <Link
            to={`/${level?.slug}`}
            className="mr-2"
            aria-current={isCurrentPage ? 'page' : undefined}
            aria-label={level?.label}
            title={level?.label}
          >
            {level?.label}
          </Link>
          <svg
            className="w-3 h-3 mx-1 text-gray-400 rtl:rotate-180"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 6 10"
            role="img"
          >
            <title>Séparateur</title>
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 9 4-4-4-4"
            />
          </svg>
        </li>
      </ol>
    </nav>
  )
}
